import { render, staticRenderFns } from "./ShowTrader.vue?vue&type=template&id=7cf1bff4&"
import script from "./ShowTrader.vue?vue&type=script&lang=js&"
export * from "./ShowTrader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports